import React, { Component } from 'react'
import PropTypes from 'prop-types'

import extractContent, {CONTENT_TYPE_HTML, CONTENT_TYPE_IMAGE} from '../helpers/extractContent'

class Paragraph extends Component {

  static contextTypes = {
    staticData: PropTypes.array,
  }

  render () {
    const {
      staticData
    } = this.context

    const {
      contentID,
      text,
      className,
    } = this.props

    const contentText = !text ? extractContent(contentID, CONTENT_TYPE_HTML, staticData): text

    return <div className={className} dangerouslySetInnerHTML={{__html: contentText}} />
  }
}

export {
  Paragraph
}



// WEBPACK FOOTER //
// ./src/components/Contents.js